<template>
    <!--  The 'triggers' prop must be define and empty like this, otherwise popover's going to be triggered on click -->
    <b-popover ref="popover" v-bind="$attrs" v-on="$listeners" placement="left" triggers="">
        <span>{{ $t('text') }}</span>
    </b-popover>
</template>

<script>
export default {
    name: 'PopoverCapsLock',
    i18n: {
        messages: {
            'en-US': {
                text: 'Caps Lock activated!',
            },
            'es-ES': {
                text: '¡Bloq Mayús activado!',
            },
            'pt-BR': {
                text: 'Caps Lock ativado!',
            },
        },
    },
}
</script>
